// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import * as React from 'react';
import { Grid } from '../../../lib/base';
import { Help } from '../../../lib/help';

export default React.memo(function ToolTipInputContainer({
  children,
  message,
}: {
  readonly children: React.ReactNode;
  readonly message: string;
}) {
  return (
    <Grid container alignItems="center" justifyContent="flex-start" spacing={2}>
      <Grid flexGrow="1">{children}</Grid>
      <Grid>
        <Help tooltip={message} />
      </Grid>
    </Grid>
  );
});
